import { locales } from 'vue-moment';
import api from './api';
import * as types from './mutation-types';

export default {
	//SSO 사용자 로그인 Action
	ssoLogin_({ state, commit, dispatch }, { token, langCd, scrId }) {
		//로그인 api 호출(base64 인코딩되어 있으니 그대로 전달)
		return api
			.ssoLogin({ token, langCd, scrId })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_LOGIN_INFO, {
						data: data.body.userInfo
					});
					commit(types.SET_MENU_MAP);

					data.header.redirectUrl = data.body.redirectUrl;
					data.header.user = data.body.userInfo.user;
				}

				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//Direct 로그인 Action
	directLogin_({ state, commit, dispatch }, { userId, userPw, langCd, scrId }) {
		//로그인 api 호출(base64 인코딩되어 있으니 그대로 전달)
		return api
			.directLogin({ userId, userPw, langCd, scrId })
			.then(data => {
				if (data.header.code === 0) {
					data.header.redirectUrl = data.body.redirectUrl;
				}

				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//사용자 로그인 Action
	login_({ state, commit, dispatch }, { userId, userPw, otp }) {
		//로그인 api 호출(base64 인코딩 후 전달)
		return api
			.login({ userId: window.btoa(userId), userPw: window.btoa(userPw), otp: window.btoa(otp) })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_LOGIN_INFO, {
						data: data.body
					});
					commit(types.SET_MENU_MAP);
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//메뉴 List 정보를 메뉴 Map 형태로 변환하여 저장하기 위한 Action
	setMenuMap_({ state, commit, dispatch }) {
		commit(types.SET_MENU_MAP);
	},

	//사용자 세션 시간 타이머 Action
	sessionTimer_({ state, commit, dispatch }) {
		commit(types.SET_SESSION_TIMER);
	},

	screenTimer_({ state, commit, dispatch }) {
		commit(types.SET_SCREEN_TIMER);
	},

	//사용자 언어 설정 변경 Action
	updateLangCd_({ state, commit, dispatch }, { langCd }) {
		//사용자 언어 설정 변경 api 호출
		return api
			.updateLangCd({ langCd, plantCd: state.user.plantCd })
			.then(data => {
				if (data.header.code === 0) {
					// store의 언어 변경 Mutation 호출
					commit(types.DEFAULT_ASSIGN, {
						key: 'langCd',
						value: langCd
					});

					dispatch('getUserMessage_'); //사용자에게 등록된 언어의 다국어 리스트 조회 Action 호출
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//사용자 색상 테마 색상 변경 Action
	updateTopSkin_({ state, commit, dispatch }, { topSkin }) {
		//사용자 색상 테마 변경 api 호출
		return api
			.updateTopSkin({ topSkin: topSkin, plantCd: state.user.plantCd })
			.then(data => {
				if (data.header.code === 0) {
					//store의 색상 테마 변경 Mutation 호출
					commit(types.DEFAULT_ASSIGN, {
						key: 'topSkin',
						value: topSkin
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//사용자 폰트 테마 변경 Action
	updateFont_({ state, commit, dispatch }, { font }) {
		//사용자 폰트 테마 변경 api 호출
		return api
			.updateFont({ font: font, plantCd: state.user.plantCd })
			.then(data => {
				if (data.header.code === 0) {
					//store의 폰트 테마 변경 Mutation 호출
					commit(types.DEFAULT_ASSIGN, {
						key: 'font',
						value: font
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//선택한 언어의 다국어 리스트 조회 Action
	getLangMessage_({ state, commit, dispatch }, { langCd }) {
		//선택한 언어의 다국어 리스트 조회 api 호출
		return api
			.getLangMessage({ langCd })
			.then(data => {
				if (data.header.code === 0) {
					//조회 해온 다국어 리스트를 Map으로 변환하여 store에 저장하기 위한 Mutation 호출
					commit(types.SET_USER_MESSAGE, {
						data: data.body
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//다국어 List 정보를 다국어 Map 형태로 변환하여 저장하기 위한 Action
	setLangMessage_({ state, commit, dispatch }) {
		commit(types.SET_USER_MESSAGE);
	},

	//사용자에게 등록된 언어의 다국어 리스트 조회 Action
	getUserMessage_({ state, commit, dispatch }) {
		//사용자에게 등록된 언어의 다국어 리스트 조회 api 호출
		return api
			.getUserMessage()
			.then(data => {
				if (data.header.code === 0) {
					//조회 해온 다국어 리스트를 Map으로 변환하여 store에 저장하기 위한 Mutation 호출
					commit(types.SET_USER_MESSAGE, {
						data: data.body
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//즐겨찾기 화면 리스트 조회 Action
	getFavorite_({ state, commit, dispatch }) {
		//즐겨찾기 화면 리스트 조회 api 호출
		return api
			.getFavorite({ plantCd: state.user.plantCd })
			.then(data => {
				if (data.header.code === 0) {
					//조회 해온 즐겨찾기 화면들을 store에 저장하기 위한 Mutation 호출
					commit(types.DEFAULT_ASSIGN, {
						key: 'favorites',
						value: data.body
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//즐겨찾기 화면 삭제 Action
	deleteFavorite_({ state, commit, dispatch }, { scrId }) {
		//즐겨찾기 화면 삭제 api 호출
		return api
			.deleteFavorite({ plantCd: state.user.plantCd, scrId })
			.then(data => {
				if (data.header.code === 0) {
					dispatch('getFavorite_'); //삭제 완료 후 즐겨찾기 리스트를 재 조회하기 위한 Action 호출
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//사용자 로그아웃 Action
	logout_({ state, commit, dispatch }) {
		//사용자 로그아웃 api 호출
		return api
			.logout()
			.then(data => {
				if (data.header.code === 0) {
					dispatch('setInitStore_'); //로그아웃 성공 후 store의 값을 초기화 하기 위한 Action 호출
				}
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//사용자 제어권 반납 Action
	userLockReturn_({ state, commit, dispatch }, { scrId }) {
		//사용자 제어권 반납 api 호출
		return api
			.userLockReturn({ scrId })
			.then(data => {
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//사용자 비밀번호 초기화 Action
	passwordInit_({ state, commit, dispatch }, { userId, email }) {
		//사용자 비밀번호 초기화를 위한 api 호출(base64 인코딩 후 전달)
		return api
			.passwordInit({ userId: window.btoa(userId), email: window.btoa(email) })
			.then(data => {
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//사용자 비밀번호 변경 Action
	passwordUpdate_({ state, commit, dispatch }, { userPwd, newUserPwd }) {
		//사용자 비밀번호 변경을 위한 api 호출(base64 인코딩 후 전달)
		return api
			.passwordUpdate({ userId: state.user.userId, userPwd: window.btoa(userPwd), newUserPwd: window.btoa(newUserPwd) })
			.then(data => {
				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//store의 값을 초기화 하기 위한 Action
	setInitStore_({ state, commit, dispatch }) {
		commit(types.SET_INIT_STORE); //store의 값을 초기화 하기 위한 Mutation 호출
	},

	//state의 값을 변경해주기 위한 유틸성 Action
	defaultAssign_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value }); //state의 값을 변경해주기 위한 유틸성 Mutation 호출
	},

	//onsite에서 화면 정보 조회하는 Action
	getScreen_({ state, commit }, { scrId }) {
		return api
			.getScreen({ scrId, plantCd: state.user.plantCd })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_SCREEN, {
						scrId: scrId,
						data: data.body
					});
				}

				return data.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//그룹웨어 연동 SSO 사용자 로그인 Action
	GwSsoLogin_({ state, commit, dispatch }) {
		//console.log('GWSSoLOGIN api 호출');
		return api
			.GwSsoLogin()
			.then(data => {
				//console.log(data);
				if (data.header.code === 0) {					
					commit(types.SET_LOGIN_INFO, {
						data: data.body
					});
					commit(types.SET_MENU_MAP);
				}
				return data.header;
			})
			.catch(error => {
				//console.log('GW sso Login Action 실패', error);
				throw error;
			});
	},



	//즐겨찾기 버튼 클릭시 Action
	onFavorite_({ state, commit }) {
		//즐겨찾기 등록된 경우 즐겨찾기 취소
		if (state.screenObj.data.favoriteYn === 'Y') {
			return api
				.deleteFavorite({ scrId: state.screenObj.scrId, plantCd: state.user.plantCd })
				.then(data => {
					if (data.header.code === 0) {
						commit(types.DEFAULT_ASSIGN, {
							key: 'screenObj',
							value: { ...state.screenObj, favoriteYn: 'N' }
						});
					}

					return data.header;
					
				})
				.catch(error => {
					throw error;
				});
		}
		//즐겨찾기 등록된 경우 즐겨찾기 취소
		else {
			return api
				.setFavorite({ scrId: state.screenObj.scrId, plantCd: state.user.plantCd })
				.then(data => {
					if (data.header.code === 0) {
						commit(types.DEFAULT_ASSIGN, {
							key: 'screenObj',
							value: { ...state.screenObj, favoriteYn: 'Y' }
						});
					}

					return data.header;
					
				})
				.catch(error => {
					throw error;
				});
		}
		
	}
};
